import dayjs from "dayjs";
import { Maybe } from "types/";

export function buildDateFilters(dateRange: {
  startDate: Maybe<dayjs.Dayjs>;
  endDate: Maybe<dayjs.Dayjs>;
}) {
  return [
    {
      field: "from_date" as const,
      operator: "eq" as const,
      value: dateRange.startDate?.format("YYYY-MM-DD"),
    },
    {
      field: "to_date" as const,
      operator: "eq" as const,
      value: dateRange.endDate?.format("YYYY-MM-DD"),
    },
  ];
}
